import { Tag, Space } from 'antd';

/**
 * 权益名称后的标签组：自定义权益（builtin=0）、展位权益（isBoothBenefit=1）
 * @param {Object} props
 * @param {number} [props.isBoothBenefit] 是否为展位权益，1 表示是
 * @param {number} [props.builtin] 是否内置权益，0 为自定义
 */
export default function BenefitTags({ isBoothBenefit, builtin }) {
    const isCustom = builtin === 0;
    const isBooth = isBoothBenefit === 1;

    if (!isCustom && !isBooth) return null;

    return (
        <Space size={4}>
            {isCustom && <Tag color="processing">自定义权益</Tag>}
            {isBooth && <Tag color="warning">展位权益</Tag>}
        </Space>
    );
}
